import * as Validation from "../../common/utils/Validation";
import API from "../../common/utils/API";
import {
    apiActionsManualEntryRecords,
} from "../../billing/manual-entry-billing-records/constants/ManualEntryRecordsActionConstants";
import {
    addNewRecord, closeBillingRecordsModal, clearBillingRecordsModal, getBillingRecords, getFormOptions,
    setBillingRecords,
    setFormOptions, toggleDeleteWarningForRecord,
    updateRecord
} from "../../billing/manual-entry-billing-records/actions/ManualEntryRecordsActions";
import {displayWarningMessage, displaySuccessMessage} from "../../common/marvel-reducers/formMessageActions";

/**
 * This is a middleware used to perform CRUD actions on the billing-records.
 * There is a validation use case written into this middleware as well.
 * @param store
 * @returns {function(*): function(*): void}
 */

const manualEntryRecordsMiddleware = (store) => (next) => (action) => {

    switch (action.type) {

        case apiActionsManualEntryRecords.GET_RECORDS: {
            next(action);

            API.getBillingRecords(action.payload.selectedRange, action.payload.authToken.idToken)
                .then(res => {
                    store.dispatch(setBillingRecords(res.data))
                })
                .catch(err => console.error(err));
            break;
        }

        case apiActionsManualEntryRecords.GET_ORG_TENANT_COUNTRIES: {
            next(action);

            API.getOrgTenantsAndCountries(action.payload.idToken)
                .then(res => {
                    store.dispatch(setFormOptions(res.data))
                })
                .catch(err => console.error(err));
            break;

        }

        case apiActionsManualEntryRecords.POST: {
            next(action);

            const { billingRecordObject, authToken, clearForm  } = action.payload;
            API.postOneBillingRecord(billingRecordObject, authToken.idToken)
                .then(res => {
                    const selectedRange = billingRecordObject.selectedYear + "-" + billingRecordObject.selectedMonth;
                    store.dispatch(getBillingRecords(selectedRange));
                    store.dispatch(getFormOptions());
                    Validation.clearMessages();
                    if( clearForm) {
                        store.dispatch(clearBillingRecordsModal());
                        store.dispatch(displaySuccessMessage(["Billing record successfully added"], true));
                    }
                    else {
                        store.dispatch(closeBillingRecordsModal());
                    }
                })
                .catch(err => console.error(err))

            break;
        }

        case apiActionsManualEntryRecords.PUT: {
            next(action);

            const { billingRecordObject, recordID, authToken } = action.payload;
            API.putOneBillingRecord(billingRecordObject, recordID, authToken.idToken)
                .then(res => {
                    const selectedRange = billingRecordObject.selectedYear + "-" + billingRecordObject.selectedMonth;
                    store.dispatch(getBillingRecords(selectedRange));
                    store.dispatch(getFormOptions());
                    Validation.clearMessages();
                    store.dispatch(closeBillingRecordsModal());
                })
                .catch(err => console.error(err))

            break;
        }

        case apiActionsManualEntryRecords.DELETE_CURRENT_RECORD: {
            next(action);

            const { recordID, selectedRange, authToken } = action.payload;
            API.deleteOneBillingRecord(recordID, authToken.idToken)
                .then(res => {
                    store.dispatch(getBillingRecords(selectedRange));
                    store.dispatch(getFormOptions());
                    store.dispatch(toggleDeleteWarningForRecord());
                })
                .catch(err => console.error(err))

            break;
        }

        case apiActionsManualEntryRecords.VALIDATE_BILLING_RECORD: {
            next(action);

            const { billingRecordObject, clearForm } = action.payload;

            // prepare the record object for API
            // sanitize the int and float type values
            billingRecordObject.item_quantity = parseInt(billingRecordObject.item_quantity);
            billingRecordObject.item_unit_price = parseFloat(billingRecordObject.item_unit_price);

            // set tenant and country to null if user has not selected a value
            // we are making tenant and country_code as completely optional here but the value is being
            // corrected per the DB expectation.
            billingRecordObject.tenant = billingRecordObject.tenant === ""
                ? null
                : billingRecordObject.tenant;
            billingRecordObject.country_code = billingRecordObject.country_code === ""
                ? null
                : billingRecordObject.country_code;

            // do not send the object for validation check if either the quantity or the unit price are 0
            if (billingRecordObject.item_unit_price === 0 || billingRecordObject.item_quantity === 0 ) {
                store.dispatch(displayWarningMessage(
                    ["Please Enter Value other than 0 for Unit Price and/or Quantity"], true));
            } else {
            // if you make this far, validate the object
                if (Validation.validateManualEntryBillingRecordForm(billingRecordObject)) {
                    if (billingRecordObject.id) {
                        const recordID = billingRecordObject.id
                        store.dispatch(updateRecord(billingRecordObject, recordID))
                    } else {
                        store.dispatch(addNewRecord(billingRecordObject, clearForm))
                    }
                }
            }

            break;
        }

        default: next(action)
    }
}

export default manualEntryRecordsMiddleware;
